/**
 * Signals that a transaction simply has no document available (HTTP 404, or a
 * transaction type that never has one), as opposed to a download that failed.
 * Callers use this to tell "nothing to attach" apart from "attaching failed".
 */
export class MissingDocumentError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'MissingDocumentError';
  }
}

export function isMissingDocumentError(error: unknown): error is MissingDocumentError {
  return error instanceof MissingDocumentError;
}
